import { render } from "./Practice.vue?vue&type=template&id=20e06ac8&ts=true"
import script from "./Practice.vue?vue&type=script&lang=ts"
export * from "./Practice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__